export default "__VITE_ASSET__DzNG2kHW__"